import DataTypes from "@/js/lookups/data-types.js";

function Statistics() {
    this.initialized = false;

    let dataTypes = new DataTypes();

    this.DATA_TYPES = dataTypes.types;

    this.TRANSFORMATION_TYPES =
        require("@/js/lookups/transformation-types.js").items;

    this.resolve = async function () {
        // Resolves array
        const promiseMap = (promiseList, functor) =>
            Promise.all(
                promiseList.map((promiseOrValue) =>
                    Promise.resolve(promiseOrValue).then(functor)
                )
            );

        // Resolves objects
        const promiseProps = (obj) =>
            Promise.all(
                Object.keys(obj).map((key) =>
                    Promise.resolve(obj[key]).then((val) => {
                        obj[key] = val;
                    })
                )
            ).then(() => obj);

        // Resolves recrusive deep objects
        const resolveNestedPromises = (obj) =>
            Promise.resolve(obj).then((obj) => {
                if (Array.isArray(obj)) {
                    return promiseMap(obj, (obj) => resolveNestedPromises(obj));
                } else if (obj && typeof obj === "object") {
                    // Object.assign(obj, obj.definition);
                    const obj2 = {};
                    for (const key in obj) {
                        obj2[key] = resolveNestedPromises(obj[key]);
                    }
                    return promiseProps(obj2);
                }
                return obj;
            });

        /**
         * Recursively resolve any promises in the this object
         */
        return await resolveNestedPromises(this);
    };

    this.translate = function ($i18n) {
        let prefix = "entityStatistics.types";
        const traverse = function (obj) {
            for (var k in obj) {
                if (typeof obj[k] === "object" && obj[k] !== null) {
                    traverse(obj[k]);
                } else if (
                    /**
                     * label is a function [ call it ]
                     */
                    obj.hasOwnProperty(k) &&
                    typeof obj[k] == "function" &&
                    k == "label"
                ) {
                    obj["label"] = obj["label"]();
                } else if (
                    /**
                     * label is NOT a function use as translation
                     */
                    obj.hasOwnProperty(k) &&
                    typeof obj[k] != "function" &&
                    k == "label"
                ) {
                    obj["label"] = $i18n.t(prefix + "." + obj[k]) || obj[k];
                }
            }
        };
        traverse(this);
    };

    this.lookupByKey = function (haystack, needle, token) {
        var token = token || "key";
        const search = function (items, key) {
            let item;
            for (var index in items) {
                item = items[index];
                if (key == _.get(item, "definition." + token)) {
                    return item;
                }
                if (item.children) {
                    let result = search(item.children, key);
                    if (result) {
                        return result;
                    }
                }
            }
        };
        return search(haystack, needle);
    };

    this.init = async function ($i18n, $store) {
        let _this = this;
        this.label = "root";
        this.children = [
            {
                definition: Object.assign({
                    aggregate: "count",
                    aggregates: false,
                    dataTypeId: "integer",
                    defaultAggregate: "count",
                    key: "SegmentCount",
                    label: "contactCount",
                    property: "pers__entity_id",
                    type: "SegmentCount",
                }),
                children: [],
            },
            {
                definition: Object.assign({
                    label: "surveys",
                }),
                children: [
                    {
                        definition: Object.assign({
                            dataTypeId: _this.DATA_TYPES.DECIMAL.id,
                            defaultAggregate: "avg",
                            key: "SegmentTrait__pers__csats",
                            label: "csats",
                            property: "pers__csats",
                            transformationTypeId:
                                _this.TRANSFORMATION_TYPES.DECIMAL.id,
                            type: "SegmentTrait",
                        }),
                        children: [],
                    },
                    {
                        definition: Object.assign({
                            aggregate: "nps",
                            aggregates: false,
                            dataTypeId: _this.DATA_TYPES.DECIMAL.id,
                            defaultAggregate: "avg",
                            key: "SegmentNps",
                            label: "nps",
                            property: "pers__nps",
                            transformationTypeId:
                                _this.TRANSFORMATION_TYPES.DECIMAL.id,
                            type: "SegmentNps",
                        }),
                        children: [],
                    },
                ],
            },
            {
                definition: Object.assign({
                    label: "health",
                }),
                children: axios
                    .get(window.akita.urls.api + "/v1/segments", {
                        params: {
                            q: [
                                "type_id[eq]=3",
                                "status_id[eq]=1",
                                "entity_type_id[eq]=2",
                            ],
                        },
                    })
                    .then(function (response) {
                        var items = [
                            // {
                            //     definition: Object.assign({
                            //         defaultAggregate: "avg",
                            //         dataTypeId: _this.DATA_TYPES.DECIMAL.id,
                            //         label: "healthScore",
                            //         property: "pers__score",
                            //         key: "SegmentScore",
                            //         transformationTypeId: _this.TRANSFORMATION_TYPES.DECIMAL.id,
                            //         type: "SegmentScore",
                            //     }),
                            //     children: [],
                            // },
                            // {
                            //     definition: Object.assign({
                            //         label: "healthScorePercentage",
                            //         type: "SegmentTrait",
                            //         property: "pers__score_percentile",
                            //         dataTypeId:  3,
                            //         transformationTypeId: 13,
                            //         defaultAggregate: "avg"
                            //     }),
                            //     children: []
                            // }
                        ];
                        response.data.data.map((segment) => {
                            items.push({
                                definition: Object.assign({
                                    defaultAggregate: "avg",
                                    key: "SegmentScoreSet__" + segment.id,
                                    label: () => {
                                        return segment.name;
                                    },
                                    property: "score_" + segment.id + "__score",
                                    segmentId: segment.id,
                                    type: "SegmentScoreSet",
                                    dataTypeId: _this.DATA_TYPES.DECIMAL.id,
                                    transformationTypeId:
                                        _this.TRANSFORMATION_TYPES.DECIMAL.id,
                                }),
                                children: [],
                            });
                            // items.push({
                            //     definition: Object.assign({
                            //         label: segment.name + ": % Rank",
                            //         type: "SegmentTrait",
                            // key: "SegmentScoreSet__" + segment.id,
                            //         property:
                            //             "score_" +
                            //             segment.id +
                            //             "__score_percentile",
                            //         dataTypeId:  3,
                            //         transformationTypeId: 13,
                            //         defaultAggregate: "avg"
                            //     }),
                            //     children: []
                            // });
                        });
                        return items;
                    }),
            },
            // {
            //     label: "usageMetrics",
            //     children: [
            //         {
            //             definition: Object.assign({
            //                 label: $i18n.t(
            //                     "entityStatistics.properties.sessionCount"
            //                 ),
            //                 type: "SegmentTrait",
            //         key: "SegmentScoreSet__" + segment.id,
            //                 property: "session_count",
            //                 dataTypeId:  3,
            //                 transformationTypeId: 2,
            //                 defaultAggregate: "avg"
            //             }),
            //             children: []
            //         }
            //     ],
            // },
            {
                definition: Object.assign({
                    label: "traitsAccounts",
                }),
                children: [
                    {
                        definition: Object.assign({
                            label: "traitsUserProvided",
                        }),
                        children: axios
                            .get(
                                window.akita.urls.api +
                                    "/v1/integration-traits",
                                {
                                    params: {
                                        q: [
                                            "provider_id[eq]=105",
                                            "interaction_type_id[eq]=2",
                                            "data_type_id[in]=2,3,9,10,11",
                                        ],
                                    },
                                }
                            )
                            .then(function (response) {
                                var items = [];
                                response.data.data.map((integrationTrait) => {
                                    items.push({
                                        definition: Object.assign({
                                            dataTypeId:
                                                integrationTrait.data_type_id,
                                            defaultAggregate: "avg",
                                            key:
                                                "SegmentTrait__" +
                                                integrationTrait.segment_identifier,
                                            label: () => {
                                                return (
                                                    integrationTrait.label ||
                                                    integrationTrait.attribute
                                                );
                                            },
                                            property:
                                                integrationTrait.segment_identifier,
                                            type: "SegmentTrait",
                                        }),
                                        children: [],
                                    });
                                });
                                return items;
                            }),
                    },
                    {
                        definition: Object.assign({
                            label: "traitsCustomFields",
                        }),
                        children: axios
                            .get(
                                window.akita.urls.api +
                                    "/v1/integration-traits",
                                {
                                    params: {
                                        q: [
                                            "provider_id[eq]=134",
                                            "interaction_type_id[eq]=2",
                                            "data_type_id[in]=2,3,9,10,11",
                                        ],
                                    },
                                }
                            )
                            .then(function (response) {
                                var items = [];
                                response.data.data.map((integrationTrait) => {
                                    items.push({
                                        definition: Object.assign({
                                            dataTypeId:
                                                integrationTrait.data_type_id,
                                            defaultAggregate: "avg",
                                            key:
                                                "SegmentTrait__" +
                                                integrationTrait.segment_identifier,
                                            label: () => {
                                                return (
                                                    integrationTrait.label ||
                                                    integrationTrait.attribute
                                                );
                                            },
                                            property:
                                                integrationTrait.segment_identifier,
                                            type: "SegmentTrait",
                                        }),
                                        children: [],
                                    });
                                });
                                return items;
                            }),
                    },
                    {
                        definition: Object.assign({
                            label: "traitsIntegrations",
                        }),
                        children: axios
                            .get(window.akita.urls.api + "/v1/integrations", {
                                params: {
                                    q: ["provider_id[notin]=105,131,134"],
                                    include: ["provider"],
                                    traits: "true",
                                },
                            })
                            .then((response) => {
                                var items = [];
                                response.data.data.map((integration) => {
                                    items.push({
                                        definition: Object.assign({
                                            label: () => {
                                                return (
                                                    integration.label ||
                                                    integration.provider.name
                                                );
                                            },
                                        }),
                                        children: axios
                                            .get(
                                                window.akita.urls.api +
                                                    "/v1/integration-traits",
                                                {
                                                    params: {
                                                        q: [
                                                            "provider_id[eq]=" +
                                                                integration.provider_id,
                                                            "interaction_type_id[eq]=2",
                                                            "data_type_id[in]=2,3,9,10,11",
                                                        ],
                                                    },
                                                }
                                            )
                                            .then(function (response) {
                                                var items = [];
                                                response.data.data.map(
                                                    (integrationTrait) => {
                                                        items.push({
                                                            definition:
                                                                Object.assign({
                                                                    dataTypeId:
                                                                        integrationTrait.data_type_id,
                                                                    defaultAggregate:
                                                                        "avg",
                                                                    key:
                                                                        "SegmentTrait__" +
                                                                        integrationTrait.segment_identifier,
                                                                    label: () => {
                                                                        return (
                                                                            integrationTrait.label ||
                                                                            integrationTrait.attribute
                                                                        );
                                                                    },
                                                                    property:
                                                                        integrationTrait.segment_identifier,
                                                                    type: "SegmentTrait",
                                                                }),
                                                            children: [],
                                                        });
                                                    }
                                                );
                                                return items;
                                            }),
                                    });
                                });
                                return items;
                            }),
                    },
                ],
            },
            {
                definition: Object.assign({
                    label: "metrics",
                }),
                children: axios
                    .get(window.akita.urls.api + "/v1/metrics", {
                        params: {
                            q: ["entity_type_id[eq]=2"],
                        },
                    })
                    .then(function (response) {
                        var items = [];
                        response.data.data.map((metric) => {
                            items.push({
                                definition: Object.assign({
                                    defaultAggregate: "avg",
                                    key: "SegmentMetric__" + metric.id,
                                    label: () => {
                                        return metric.name;
                                    },
                                    metricId: metric.id,
                                    type: "SegmentMetric",
                                    dataTypeId: (metric) => {
                                        /** METRICS USE DIFFERENT IDS **/
                                        switch (metric.data_type_id) {
                                            case 1: // INT
                                            case 6: // PERCENTAGE INT
                                                return _this.DATA_TYPES.INTEGER
                                                    .id;
                                                break;
                                            case 4: // CURRENCY INT (DOLLARS.CENTS)
                                            case 2: // DECIMAL
                                                return _this.DATA_TYPES.DECIMAL
                                                    .id;
                                                break;
                                            case 3: // CURRENCY CENTS
                                                return _this.DATA_TYPES
                                                    .CURRENCY_CENTS.id;
                                                break;
                                            case 5: // PERCENTAGE
                                                return _this.DATA_TYPES
                                                    .PERCENTAGE.id;
                                                break;
                                        }
                                    },
                                    transformationTypeId: (metric) => {
                                        /** METRICS USE DIFFERENT IDS **/
                                        switch (metric.data_type_id) {
                                            case 1: // int
                                                return _this
                                                    .TRANSFORMATION_TYPES
                                                    .INTEGER.id;
                                                break;
                                            case 2: // DECIMAL
                                                return _this
                                                    .TRANSFORMATION_TYPES
                                                    .DECIMAL.id;
                                                break;
                                            case 3:
                                                return _this.DATA_TYPES.CURRENCY
                                                    .id;
                                                break;
                                            case 4: // CURRENCY INT (DOLLARS.CENTS)
                                                return _this
                                                    .TRANSFORMATION_TYPES
                                                    .CURRENCY.id;
                                                break;
                                            case 5: // PERCENTAGE
                                                return _this.DATA_TYPES
                                                    .PERCENTAGE.id;
                                                break;
                                            case 6: // PERCENTAGE INT
                                                return _this
                                                    .TRANSFORMATION_TYPES
                                                    .PERCENTAGE.id;
                                                break;
                                        }
                                    },
                                }),
                                children: [],
                            });
                        });
                        return items;
                    }),
            },
        ];

        let result = await this.resolve();
        result.translate($i18n);
        this.children = result.children;
        this.initialized = true;
    };
}

export default Statistics;
